<template>
  <b-container fluid>
    <b-row align-h="between">
      <b-col cols="auto">
        <b-button
          variant="success"
          @click="addOption(null)"
        >
          เพิ่มตัวเลือก
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-table
        responsive
        striped
        hover
        bordered
        :fields="fields"
        :items="selectedOptions"
      >
        <template
          slot="has_text_field"
          slot-scope="data"
        >
          <div class="col-left">
            {{ data.item.has_text_field ? 'มี' : 'ไม่มี' }}
          </div>
        </template>
        <template
          slot="action"
          slot-scope="data"
        >
          <b-container fluid>
            <b-row align-h="center">
              <b-col cols="auto">
                <fa-icon
                  :icon="['fas', 'edit']"
                  class="icon warning"
                  @click="editOption(data.item.name, data.item.has_text_field)"
                />
              </b-col>
              <b-col cols="auto">
                <fa-icon
                  :icon="['fas', 'trash']"
                  class="icon danger"
                  @click="deleteOption(data.item.name, data.item.has_text_field)"
                />
              </b-col>
            </b-row>
          </b-container>
        </template>
      </b-table>
    </b-row>
  </b-container>
</template>

<script>
import Swal from 'sweetalert2';

  export default {
    name: "OptionInputModal",
    props: {
      selectedOptions: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        fields: [
                {
                    key: 'name',
                    label: 'ชื่อตัวเลือก'
                },
                {
                    key: 'has_text_field',
                    label: 'มีป้อนข้อมูลเพิ่มเติม'
                },
                {
                    key: 'action',
                    label: 'ACTION'
                }
            ],
      }
    },
    methods: {
      async addOption() {
        const result = await Swal.mixin({
                  confirmButtonText: 'Next &rarr;',
                  showCancelButton: true,
                  progressSteps: ['1', '2']
              }).queue([
                  {
                      input: 'text',
                      title: 'ชื่อตัวเลือก',
                  },
                  {
                      title: 'มีป้อนข้อมูลเพิ่มเติม',
                      text: 'มีป้อนข้อมูลเพิ่มเติมในตัวเลือก',
                      input: 'select',
                      inputOptions: ['ไม่มี', 'มี']
                  },
              ])

        if (result.value) {
            const name = result.value[0]
            const has_text_field = '0' !== result.value[1]
            let newOption = { name, has_text_field};

            this.$emit('update:selectedOptions', [...this.selectedOptions, newOption])
        }
      },
      async editOption(name, has_text_field) {

        let selectedOptions = this.selectedOptions
        let selectedOptionsIndex = selectedOptions.findIndex(option => option.name === name && option.has_text_field === has_text_field)
        const result = await Swal.mixin({
                  confirmButtonText: 'Next &rarr;',
                  showCancelButton: true,
                  progressSteps: ['1', '2']
              }).queue([
                  {
                      input: 'text',
                      title: 'ชื่อตัวเลือก',
                  },
                  {
                      title: 'มีป้อนข้อมูลเพิ่มเติม',
                      text: 'มีป้อนข้อมูลเพิ่มเติมในตัวเลือก',
                      input: 'select',
                      inputOptions: ['ไม่มี', 'มี']
                  },
              ])

        if (result.value) {
            const name = result.value[0]
            const has_text_field = '0' !== result.value[1]
            selectedOptions[selectedOptionsIndex] = { ...selectedOptions[selectedOptionsIndex], name, has_text_field};
        }

        this.$nextTick(() => {
          this.$emit('update:selectedOptions', selectedOptions)
        })
      },
      deleteOption(name, has_text_field) {

              let selectedOptions = this.selectedOptions.filter(option => option.name !== name && option.has_text_field !== has_text_field)

              Swal.fire({
                  title: 'ยืนยันการลบ?',
                  text: `คุณต้องการที่จะลบตัวเลือก ${this.selectedOptions.find(option => option.name === name).name} ใช่หรือไม่`,
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'ใช่ ยืนยันการลบ!',
                  cancelButtonAriaLabel: 'ยกเลิก'
              }).then((result) => {
                  if (result.value) {
                      this.$emit('update:selectedOptions', selectedOptions)
                  }
              })
          },
    }
  }
</script>

<style lang='scss' scoped>
    .icon {
        cursor: pointer;
        &.warning {
            color: #ffc107 ;
        }
        &.danger {
            color: #dc3545;
        }
        &.disable {
            opacity: 0.4;
            cursor: default;
        }
    }

</style>
